export const spacings = {
	XXL: "64px",
	XL: "48px",
	L: "32px",
	M: "24px",
	S: "16px",
	XS: "8px",
} as const;
